import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _call_super } from "@swc/helpers/_/_call_super";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import batchDeprecatedEvents from "@faire/web-api--source/api/v2/events/post";
import { IPublishUserEventsRequest } from "@faire/web-api--source/indigofair/data/IPublishUserEventsRequest";
import { BatchEventsQueue } from "./BatchEventsQueue";
export var UserEventsQueue = /*#__PURE__*/ function(BatchEventsQueue) {
    "use strict";
    _inherits(UserEventsQueue, BatchEventsQueue);
    function UserEventsQueue() {
        _class_call_check(this, UserEventsQueue);
        var _this;
        _this = _call_super(this, UserEventsQueue);
        _this.batchEvents = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(events) {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                batchDeprecatedEvents("events.api", IPublishUserEventsRequest.build({
                                    events: events,
                                    is_validation: false
                                }))
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(events) {
                return _ref.apply(this, arguments);
            };
        }();
        return _this;
    }
    return UserEventsQueue;
}(BatchEventsQueue);
